/** Duration-phase card for the welcome plan tour (resize hint). */
import { Box, Button, Paper, Typography } from '@mui/material';
import { useT } from '@/i18n/useT';
import { ONBOARDING_WELCOME_PLAN_TOUR_TEST_IDS } from '@/features/onboarding/constants/welcomePlanTour';
import { onboardingHintCardPositionSx } from '@/features/onboarding/utils/onboardingHintCardSx';

/**
 * @param {Object} props
 * @param {() => void} props.completeDuration
 */
const OnboardingWelcomePlanTourDuration = ({ completeDuration }) => {
  const t = useT();

  return (
    <Paper
      variant="outlined"
      data-testid={ONBOARDING_WELCOME_PLAN_TOUR_TEST_IDS.duration}
      sx={onboardingHintCardPositionSx}
      role="region"
    >
      <Typography variant="body2" sx={{ mb: 1.5 }}>
        {t(
          'onboarding.duration.body',
          'Standaard duurt een taak 15 minuten. Sleep de onderrand om dat aan te passen.',
        )}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="contained" size="small" onClick={completeDuration}>
          {t('onboarding.duration.next', 'Volgende')}
        </Button>
      </Box>
    </Paper>
  );
};

export default OnboardingWelcomePlanTourDuration;
